import Vue from 'vue'
import { GET_CONTENTS, ERROR_XHR } from '../mutation-types.js'

export const getContents = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('content')
    .then(
      (response) => {
        dispatch(GET_CONTENTS, response.json())
        resolve()
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/contentActions.js